const buttonClasses = 'text-neutrals-500';

const buttonHoverClasses = 'hover:bg-neutrals-200 hover:text-neutrals-700 [&:hover_svg]:fill-neutrals-700';

const buttonIconClasses = 'fill-neutrals-500';

const buttonGhostClasses = { buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses], buttonIconClasses };

export default buttonGhostClasses;
